import "./ActionButtons.css";

import { Button } from "../Button";

interface ActionButtonsProps {
  submitButtonLabel?: string;
  cancelButtonLabel?: string;
  loadingText?: string;
  fullWidth?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  corners?: "default" | "rounded";
  onCancel: () => void;
}

export const ActionButtons = ({
  submitButtonLabel = "Save",
  cancelButtonLabel = "Cancel",
  loadingText = "Loading",
  fullWidth = false,
  isLoading = false,
  disabled = false,
  onCancel,
  corners,
}: ActionButtonsProps): JSX.Element => {
  return (
    <div className="ActionButtons">
      <Button
        text={submitButtonLabel}
        type="submit"
        fullWidth={fullWidth}
        isLoading={isLoading}
        loadingText={loadingText}
        disabled={disabled}
        corners={corners}
      />
      <Button variant="secondary" text={cancelButtonLabel} onClick={onCancel} fullWidth={fullWidth} corners={corners} />
    </div>
  );
};
